import React from 'react';

/**
 * Left panel: room list with progress bar.
 * Shows all rooms with check/uncheck, name, area.
 * Click selects the room on canvas + opens right panel.
 */
export default function LeftPanel({ rooms, selectedRoom, onSelectRoom }) {
  const totalRooms = rooms.length;
  const completedRooms = rooms.filter(r => r.ok).length;
  const progress = totalRooms > 0 ? (completedRooms / totalRooms) * 100 : 0;

  return (
    <div style={{
      width: 200,
      minWidth: 200,
      height: '100%',
      borderRight: '1px solid #E5E7EB',
      display: 'flex',
      flexDirection: 'column',
      background: '#FFFFFF',
      overflow: 'hidden',
    }}>
      {/* Header */}
      <div style={{
        padding: '12px 14px',
        borderBottom: '1px solid #E5E7EB',
        fontWeight: 700,
        fontSize: 13,
        color: '#1E3A5F',
        fontFamily: 'Inter, sans-serif',
      }}>
        Cômodos ({totalRooms})
      </div>

      {/* Room list */}
      <div style={{
        flex: 1,
        overflowY: 'auto',
        padding: '4px 0',
      }}>
        {rooms.map((room, idx) => (
          <div
            key={room.id || idx}
            onClick={() => onSelectRoom(idx)}
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: 8,
              padding: '8px 14px',
              cursor: 'pointer',
              background: selectedRoom === idx ? '#FFF7ED' : 'transparent',
              borderLeft: selectedRoom === idx ? '3px solid #F97316' : '3px solid transparent',
              transition: 'all 0.15s',
            }}
            onMouseEnter={(e) => {
              if (selectedRoom !== idx) e.currentTarget.style.background = '#F9FAFB';
            }}
            onMouseLeave={(e) => {
              if (selectedRoom !== idx) e.currentTarget.style.background = 'transparent';
            }}
          >
            <span style={{ fontSize: 14 }}>
              {room.ok ? '✅' : '◻️'}
            </span>
            <div style={{ flex: 1, minWidth: 0 }}>
              <div style={{
                fontSize: 12,
                fontWeight: 600,
                color: '#1E3A5F',
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                fontFamily: 'Inter, sans-serif',
              }}>
                {room.nome}
              </div>
              <div style={{
                fontSize: 10,
                color: '#9CA3AF',
                fontFamily: 'Inter, sans-serif',
              }}>
                {room.area} m²
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Progress bar */}
      <div style={{
        padding: '12px 14px',
        borderTop: '1px solid #E5E7EB',
      }}>
        <div style={{
          display: 'flex',
          justifyContent: 'space-between',
          marginBottom: 6,
          fontSize: 11,
          color: '#6B7280',
          fontFamily: 'Inter, sans-serif',
        }}>
          <span>Acabamentos</span>
          <span style={{ fontWeight: 600 }}>{completedRooms}/{totalRooms}</span>
        </div>
        <div style={{
          height: 6,
          background: '#E5E7EB',
          borderRadius: 3,
          overflow: 'hidden',
        }}>
          <div style={{
            height: '100%',
            width: `${progress}%`,
            background: progress === 100 ? '#22C55E' : '#F97316',
            borderRadius: 3,
            transition: 'width 0.3s ease',
          }} />
        </div>
      </div>
    </div>
  );
}
